export default "__VITE_ASSET__BEZAA_sQ__"